import styled from 'styled-components';

import {
  TScrollFadeContentProps,
  TScrollFadeViewportProps,
} from '@/shared/components/ui/scroll-fade/scroll-fade.types';
import { getScrollFadeMask } from '@/shared/components/ui/scroll-fade/scroll-fade.utils';

export const ScrollFadeViewport = styled.div<TScrollFadeViewportProps>`
  max-height: ${({ $maxHeight }) => $maxHeight};
  overflow-y: auto;
  mask-image: ${getScrollFadeMask};
  -webkit-mask-image: ${getScrollFadeMask};
`;

export const ScrollFadeContent = styled.div<TScrollFadeContentProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap};
`;
